export enum Permissions {
  Admin = "org:sys_domains:manage",
  Member = "org:sys_memberships:read",
}
